import { CatalogSearchCriteria, CatalogSearchCriteriaType } from '../../../..';

export class ChangeSearchCriteriaByCatalogType {
  static readonly type = '[CatalogSearchCriteria] Change CatalogSearchCriteria By Catalog Type';
  constructor(
    public payload: {
      searchCriteria: Partial<CatalogSearchCriteria>;
      catalogSearchCriteriaType: CatalogSearchCriteriaType;
    },
  ) {}
}

export class SearchCriteriaInitialStateByCatalogType {
  public static readonly type = '[CatalogSearchCriteria] Set initial state By Catalog Type';
  constructor(public payload: CatalogSearchCriteriaType) {}
}

export class GetSavedSearchCriteriaByCatalogTypeFromStorage {
  public static readonly type = '[CatalogSearchCriteria] Get Saved Search Criteria By Catalog Type From Storage';

  constructor(public payload: CatalogSearchCriteriaType) {}
}

export class SetSearchCriteriaByCatalogTypeToStorage {
  public static readonly type = '[CatalogSearchCriteria] Set Search Criteria By Catalog Type To Storage';

  constructor(
    public payload: {
      searchCriteria: Partial<CatalogSearchCriteria>;
      catalogSearchCriteriaType: CatalogSearchCriteriaType;
    },
  ) {}
}
